import "./Loading.css";
const Loading = ({
  loading = false,
  backgroundColor = "#ffffff",
  loaderColor = "#fe414d",
}) => {
  return (
    <>
      {loading ? (
        <div
          className="Loading-background"
          style={{ background: backgroundColor }}
        >
          <div className="Loading-bar">
            <div
              className="Loading-circle-1"
              style={{ background: loaderColor }}
            />
            <div
              className="Loading-circle-2"
              style={{ background: loaderColor }}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Loading;
